import { apiClient } from './apiClient.js'

export const userProfileApi = {
	fetchUserProfile: async (userId, config, accessToken) => {
		const url = `${config.securityServiceBaseUrl}/api/userProfiles/${userId}`
		return await apiClient(
			url,
			accessToken,
			{
				method: "GET"
			},
			async (response) => {
				return await response.json().then(
					(result) => {
						return result.userProfile
					}
				)
			}
		)
	},
	updateUserProfile: async (userId, userProfile, config, accessToken) => {
		const url = `${config.securityServiceBaseUrl}/api/userProfiles/${userId}`
		return await apiClient(
			url,
			accessToken,
			{
				method: "POST",
				headers: {
					'X-HTTP-Method-Override': 'PUT'
				},
				body: JSON.stringify(userProfile)
			},
			async (response) => {
				return await response.json().then(
					(result) => {
						return result.userProfile
					}
				)
			}
		)
	}
}

export default userProfileApi